<template>
  <div>
    <nav class="navbar navbar-expand-lg navbar-dark bg-primary sticky-top mb-5">
      <div class="container-xl">
        <h4 class="navbar-brand w-25 mb-0">
          <LogoPublic />
        </h4>
      </div>
    </nav>

    <div class="container-xl text-container" style="max-width: 40rem;">
      <div class="my-4">
        <!-- Success -->
        <div v-if="success" class="alert alert-success">
          <h4 class="alert-heading">Account created</h4>
          <p>
            We have sent an e-mail to
            <b>{{ email }}</b>
            with a link to set your password.
          </p>
          <p v-if="linked_bookings > 0">
            Your booking has been linked to the new account.
          </p>
          <a class="btn btn-primary" :href="loginUrl">Log in</a>
        </div>

        <!-- Account exists -->
        <div v-else-if="accountExists" class="alert alert-info">
          <h4 class="alert-heading">Account already exists</h4>
          <p>
            An account with e-mail
            <b>{{ email }}</b>
            already exists.
          </p>
          <a class="btn btn-primary" :href="loginUrl">Log in</a>
        </div>

        <!-- Form -->
        <form v-else @submit.prevent="submitRegister()">
          <h2>Create your account</h2>
          <p class="text-muted">
            Create an account to link your event booking to your profile.
          </p>
          <div
            v-if="error"
            class="alert alert-danger"
          >
            {{ error }}
          </div>
          <div class="mb-3">
            <label class="form-label">E-mail</label>
            <input :value="email" class="form-control" type="email" disabled>
          </div>
          <div class="mb-3">
            <label class="form-label">First name</label>
            <input v-model.trim="first_name" class="form-control" type="text" />
          </div>
          <div class="mb-3">
            <label class="form-label">Last name</label>
            <input v-model.trim="last_name" class="form-control" type="text" />
          </div>
          <button
            class="btn btn-primary"
            type="submit"
            :disabled="saving"
          >
            <span v-if="saving" class="spinner-border spinner-border-sm me-2"></span>
            Create account
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import LogoPublic from "./LogoPublic.vue";

const store = useStore();
const route = useRoute();

const email = ref("");
const first_name = ref("");
const last_name = ref("");
const return_url = ref("/");
const error = ref("");
const saving = ref(false);
const success = ref(false);
const accountExists = ref(false);
const linked_bookings = ref(0);

const loginUrl = computed(() => "/login?return=" + encodeURIComponent(return_url.value));

onMounted(() => {
  email.value = route.query.email || "";
  first_name.value = route.query.first_name || "";
  last_name.value = route.query.last_name || "";
  if (typeof route.query.return === "string" && route.query.return.startsWith("/")) {
    return_url.value = route.query.return;
  }
  if (!email.value) {
    error.value = "Missing e-mail";
  }
});

function submitRegister () {
  error.value = "";
  saving.value = true;
  store.dispatch("event_register", {
    email: email.value,
    first_name: first_name.value,
    last_name: last_name.value
  }).then((resp) => {
    saving.value = false;
    if (resp.status === 409) {
      accountExists.value = true;
      return;
    }
    if (resp.data && resp.data.status === "ok") {
      success.value = true;
      linked_bookings.value = resp.data.linked_bookings || 0;
    } else {
      error.value = (resp.data && resp.data.error) ? resp.data.error : "Registration failed";
    }
  }).catch(() => {
    saving.value = false;
    error.value = "Registration failed";
  });
}
</script>
